module.exports = __webpack_public_path__ + "static/media/zolaicons.8f1bec8a.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/zolaicons.eot?24613844
 ** module id = 368
 ** module chunks = 50
 **/